import React from 'react'

import type { useFloatingElement } from 'hooks/useFloatingElement'

type FloatingElement = ReturnType<typeof useFloatingElement>

export type DropdownPropsContextValue = Pick<
  FloatingElement,
  'arrowRef' | 'arrowStyle' | 'floatingStyle' | 'middlewareData' | 'reference'
> & {
  // `floating` is the hook's setter merged with Dropdown's own ref, so it is
  // a plain callback ref rather than the hook's original.
  floating: React.RefCallback<HTMLElement>
  hasArrow: boolean
  isToggled: boolean
}

export type DropdownHandlersContextValue = {
  onDismiss: () => void
  onToggle: (event: Event | React.MouseEvent<HTMLElement>) => void
}

export const DropdownPropsContext = React.createContext<
  DropdownPropsContextValue | undefined
>(undefined)
export const DropdownHandlersContext = React.createContext<
  DropdownHandlersContextValue | undefined
>(undefined)
